export default __webpack_public_path__ + "static/media/16.1fd48cc1.png";